<template>
  <van-popup :value="value" class="sl-password-popup" round position="bottom" get-container="body" :close-on-click-overlay="false" @input="$emit('input', $event)" @closed="clear">
    <section class="sl-password-gate" role="dialog" aria-modal="true" :aria-label="isSetup ? '設定平台提現密碼' : '驗證平台提現密碼'">
      <span class="sl-password-badge">SWEETLOVE · 帳戶安全</span>
      <h2>{{ isSetup ? '先設定平台提現密碼' : '驗證平台提現密碼' }}</h2>
      <p>{{ isSetup ? '設定完成後，才會進入收款帳戶資料頁。' : '請輸入您設定的平台提現密碼，以確認本次提現。' }}</p>
      <p class="sl-password-explanation"><strong>這不是銀行卡密碼</strong><br>此密碼僅用於 SweetLove 平台提現。請勿輸入銀行卡密碼、網銀密碼或銀行驗證碼。</p>
      <van-field v-model="password" type="password" inputmode="numeric" maxlength="4" autocomplete="new-password" label="平台提現密碼" placeholder="請輸入 4 位數字" :disabled="saving || busy" />
      <van-field v-if="isSetup" v-model="confirmation" type="password" inputmode="numeric" maxlength="4" autocomplete="new-password" label="再次確認密碼" placeholder="請再次輸入平台提現密碼" :disabled="saving || busy" />
      <van-button block round class="sl-password-primary" :loading="saving || busy" @click="submit">{{ isSetup ? '設定完成並繼續' : '確認提現' }}</van-button>
      <van-button block round plain :disabled="saving || busy" @click="cancel">取消</van-button>
      <p v-if="!isSetup" class="sl-password-help">忘記平台提現密碼，請聯絡管理員處理。</p>
    </section>
  </van-popup>
</template>
<script>
export default {
  props: { value: Boolean, isSetup: Boolean, busy: Boolean },
  data() { return { password: '', confirmation: '', saving: false } },
  watch: { value(open) { if (!open) this.clear() } },
  methods: {
    clear() { this.password = ''; this.confirmation = '' },
    cancel() { this.clear(); this.$emit('input', false); this.$emit('cancel') },
    async submit() {
      if (this.saving || this.busy) return
      if (!/^\d{4}$/.test(this.password)) return this.$toast('請輸入 4 位數字的平台提現密碼')
      if (this.isSetup && this.password !== this.confirmation) return this.$toast('兩次輸入的密碼不一致')
      this.saving = true
      try {
        if (this.isSetup) {
          const response = await this.$http({ method: 'post', url: 'user_set_paypw', data: { paypassword: this.password, confirmation: this.confirmation } })
          if (!response || response.code !== 200) return this.$toast((response && response.msg) || '設定失敗，請稍後重試')
          this.$emit('input', false)
          this.clear()
          this.$emit('complete')
        } else {
          const password = this.password
          this.clear()
          this.$emit('complete', password)
        }
      } catch (error) { this.$toast('連線失敗，請稍後重試') }
      finally { this.saving = false }
    },
  },
}
</script>
<style lang="less">
/* Dialog mounts on body; rem values stay readable on phones and desktops. */
body .sl-password-popup.van-popup { width: 100%; max-width: 32rem; left: 50%; right: auto; bottom: 0; margin-left: 0; transform: translateX(-50%); max-height: 92%; overflow-y: auto; background: rgba(255, 252, 255, .97); color: #382844; box-shadow: 0 -.5rem 3rem rgba(51, 22, 68, .16); }
body .sl-password-popup.van-popup--bottom.van-popup--round { border-radius: 1.5rem 1.5rem 0 0; }
.sl-password-gate { box-sizing: border-box; padding: 1.5rem 1.25rem calc(1.25rem + env(safe-area-inset-bottom)); font-size: 1rem; }
.sl-password-gate h2 { font-size: 1.35rem; line-height: 1.4; margin: .6rem 0; color: #382844; }
.sl-password-gate p { font-size: .88rem; line-height: 1.65; margin: .75rem 0; color: #73677b; }
.sl-password-badge { color: #9c26ac; font-size: .72rem; letter-spacing: .08em; }
.sl-password-gate .sl-password-explanation { padding: .8rem 1rem; border-radius: .9rem; background: #f6edf8; color: #754080; }
.sl-password-explanation strong { color: #8d249b; font-size: 1rem; }
.sl-password-gate .van-cell { box-sizing: border-box; padding: .85rem .9rem; background: #fff; border: 1px solid #e8deec; border-radius: .8rem; margin: .75rem 0; font-size: 1rem; line-height: 1.5; }
.sl-password-gate .van-field__label { width: 7em; color: #58465f; }
.sl-password-gate .van-field__control { color: #382844; font-size: 1rem; }
.sl-password-gate .van-button { height: 3.2rem; margin-top: .75rem; font-size: 1rem; border: 1px solid #e5d9ea; color: #6b4b76; background: #fff; }
.sl-password-gate .sl-password-primary { color: #fff; border: none; background: linear-gradient(100deg, #881be8, #d515ad); }
.sl-password-gate .sl-password-help { margin-bottom: 0; text-align: center; font-size: .78rem; }
</style>
